import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=70e0547f&scoped=true"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=70e0547f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e0547f",
  null
  
)

export default component.exports